export const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
};
const theme = {
  colors: {
    // Azul claro AeC
    defaultColor: '#005156',
    defaultColorHover: '#01090a',
    // Azul escuro AeC
    titleColor: '#005156',
    colorLabelDefault: '#005156',
    whiteDefault: 'white',
    errorColor: '#F17090',
    labelSecondary: '#a5a5a5e0',
    gray: '#FBFBFB',
    softGray: '#005156',
    darkGray: '#4a4a4a',
    ligthGray: '#cfcfcf',
    inputTextColor: '#bababa',
    borderRadius: '#dcdcdc',
    cardColor: '#f8f8f8',
    iconColor: '#818181',
    softGreen: '#8bc63f',
    spanColor: '#9b9b9b',
    orangeColor: '#edce60',
  },
  font: {
    fontSizeDefault: '12px',
  },
  size: {
    mobileS: `(max-width: ${size.mobileS})`,
    mobileM: `(min-width: ${size.mobileM})`,
    mobileL: `(min-width: ${size.mobileL})`,
    tablet: `(min-width: ${size.tablet})`,
    laptop: `(min-width: ${size.laptop})`,
    laptopL: `(min-width: ${size.laptopL})`,
    desktop: `(min-width: ${size.desktop})`,
    desktopL: `(min-width: ${size.desktop})`,
  },
  defineColor: (color) => {
    switch (color) {
      case 'gray':
        return theme.colors.gray;
      case 'darkGray':
        return theme.colors.darkGray;
      case 'softGray':
        return theme.colors.softGray;
      case 'softGreen':
        return theme.colors.softGreen;
      case 'default':
        return theme.colors.defaultColor;
      case 'errorColor':
        return theme.colors.errorColor;
      default:
        return theme.colors.titleColor;
    }
  },
  aecColors:{
    
  }
};

export default theme;
